export default __webpack_public_path__ + "static/media/contractorImage.8cf8a855.svg";